import { Grid, makeStyles, Typography, Box, Button } from '@material-ui/core';
import React, { FC, useMemo } from 'react';
import { ViewState } from '../../../../domain/models/ViewState';
import { useOrdering } from '../../../../stores/OrderingStore';
import { QRCodeSVG } from 'qrcode.react';
import CurrencyFormat from '../../../Core/CurrencyFormat/CurrencyFormat';
import { Link } from 'react-navi';
import { OnlineOrderingStore } from 'kiolyn-api';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    lineHeight: '26pt'
  },
  icon: {
    margin: theme.spacing(8)
  },
  typo: {
    whiteSpace: 'pre-wrap'
  }
}));

const QrCodeApplePay: FC = () => {
  const classes = useStyles();
  const orderingStore = useOrdering();
  const isSandbox = (orderingStore.store as OnlineOrderingStore).is_sandbox;

  const paymentLink = useMemo(
    () =>
      `${window.location.origin}/stores/${orderingStore.store?.id}/orders/${orderingStore.order?.id}/payments/applepay`,
    [orderingStore.store, orderingStore.order]
  );

  return (
    <Grid
      container
      className={classes.container}
      direction="column"
      alignContent="center"
      alignItems="center"
      justify="center"
    >
      <Box>
        <QRCodeSVG value={paymentLink} />
        {isSandbox && (
          <Box>
            <Link target="_blank" href={paymentLink}>
              Link to Pay
            </Link>
          </Box>
        )}
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6">Total:</Typography>
          <Typography variant="h6">
            <CurrencyFormat amount={orderingStore.order.total} />
          </Typography>
        </Box>
      </Box>

      <Box marginTop={4} marginBottom={2}>
        <Typography color="textSecondary" variant="h6" align="center">
          Please scan the QR code with your Apple device
        </Typography>
      </Box>
      <Button
        color="primary"
        onClick={() => {
          orderingStore.submitState = ViewState.NONE;
          orderingStore.isSelectPaymentMethod = true;
          orderingStore.websocket?.close();
        }}
      >
        Change payment method
      </Button>
    </Grid>
  );
};

export default QrCodeApplePay;
